export default __webpack_public_path__ + "6f2a1c6841e6469b6c9d623fd6d6895c.png";